import Router from 'vue-router';
import options from './options';
import { createGuards } from './methods';

const router = new Router(options);

createGuards(router);

export default router;
